import React from "react";

type SvgNode = {
  tag: string;
  attrs?: Record<string, any>;
  children?: (SvgNode | string)[];
};

function renderNode(node: SvgNode | string, key: number): React.ReactNode {
  if (typeof node === "string") return node;
  const { tag, attrs = {}, children = [] } = node;
  const rendered = children.map((child, i) => renderNode(child, i));
  return React.createElement(tag, { key, ...attrs }, ...rendered);
}

export default function SvgViewer({ data }: { data: string }) {
  let root: SvgNode;
  try {
    root = typeof data === "string" ? JSON.parse(data) : data;
  } catch (e) {
    return null;
  }
  if (!root?.tag) return null;
  return (
    <div className="my-8 not-prose overflow-x-auto">
      {renderNode(root, 0)}
    </div>
  );
}
